import React from 'react';
import { orderStatusOptions } from '../customerOrdersTypes';
import styles from './OrdersFilters.module.css';

interface OrdersFiltersProps {
  status: string;
  onStatusChange: (value: string) => void;
  date: string;
  onDateChange: (value: string) => void;
}

export const OrdersFilters: React.FC<OrdersFiltersProps> = ({
  status,
  onStatusChange,
  date,
  onDateChange,
}) => {
  return (
    <div className={styles.bar}>
      <div className={styles.selectWrapper}>
        <select
          value={status}
          onChange={(e) => onStatusChange(e.target.value)}
          className={styles.select}
        >
          {orderStatusOptions.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
        <svg viewBox="0 0 24 24" fill="currentColor" className={styles.chevron}>
          <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
        </svg>
      </div>
      <div className={styles.dateWrapper}>
        <input
          type="date"
          value={date}
          onChange={(e) => onDateChange(e.target.value)}
          className={styles.dateInput}
          placeholder="mm/dd/yyyy"
        />
      </div>
    </div>
  );
};
